import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import et from './locales/et.json'
import { useLanguageStore } from '../stores/language'

export function setupI18n() {
  const i18n = createI18n({
    legacy: false, // you must set `false`, to use Composition API
    locale: 'en', // default language
    fallbackLocale: 'en',
    messages: {
      en,
      et
    },
    silentTranslationWarn: true,
    silentFallbackWarn: true
  })

  // Watch for language changes in the store
  const languageStore = useLanguageStore()
  
  // Set initial language from store
  i18n.global.locale.value = languageStore.language
  
  // Watch for language changes
  languageStore.$subscribe((mutation, state) => {
    i18n.global.locale.value = state.language
    // Store language preference in localStorage
    localStorage.setItem('language', state.language)
  })
  
  // Initialize language from localStorage if available
  const savedLanguage = localStorage.getItem('language')
  if (savedLanguage) {
    languageStore.setLanguage(savedLanguage)
  }

  return i18n
}